module.exports = __webpack_public_path__ + "static/img/se.fd663a70.svg";